import { Button, SxProps } from '@mui/material';

export interface PreviewModeProps {
  sx?: SxProps;
  variant?: 'contained' | 'text';
  text?: string;
}

function PreviewMode({ sx, variant, text }: PreviewModeProps) {
  const isPreviewMode = new URL(window.location.href).searchParams.has(
    'preview',
  );

  const handlePreviewToggle = () => {
    const url = new URL(window.location.href);
    const hasPreview = url.searchParams.has('preview');
    if (hasPreview) {
      url.searchParams.delete('preview');
    } else {
      url.searchParams.set('preview', 'true');
    }

    window.location.href = url.toString();
  };

  const buttonVariant = variant ?? (isPreviewMode ? 'contained' : 'text');

  return (
    <Button
      variant={buttonVariant}
      size="small"
      color="secondary"
      onClick={handlePreviewToggle}
      sx={sx}
    >
      {text ?? (isPreviewMode ? 'Exit Preview Mode' : 'Enter Preview Mode')}
    </Button>
  );
}

export default PreviewMode;
